import {
  decodePropertyTypeDetails,
  reverseFormatPropertyTitle,
} from "utils/formatUrl";
import { floorMapping } from "utils/mapping";
import {
  findLocationFromUrl,
  findSortByOption,
  formatPropertyType,
  propertyTypeDetailsList,
} from "utils/searchFilter";
import locations from "../Map/locations.json";

export const createFiltersFromUrl = (urlString) => {
  const url = new URL(urlString, window.location.origin);
  const searchParams = url.searchParams;

  const propertyType = searchParams.get("propertyType");
  const propertyTypeDetails = searchParams.get("propertyTypeDetails");
  const zipCodes = searchParams.getAll("zip");
  const locationIdParams = searchParams.getAll("locationId") || [];
  const searchedLocations = findLocationFromUrl(locationIdParams);
  const polygonsParam = searchParams.get("polygons");
  const polygons = polygonsParam
    ? JSON.parse(decodeURIComponent(polygonsParam))
    : [];
  const zoneIds = searchParams.getAll("zoneId").map(Number);
  const priceMin = searchParams.get("priceMin");
  const priceMax = searchParams.get("priceMax");
  const totalAreaMin = searchParams.get("surfaceMin");
  const totalAreaMax = searchParams.get("surfaceMax");
  const roomMin = searchParams.get("roomMin");
  const roomMax = searchParams.get("roomMax");
  const bedroomMin = searchParams.get("bedroomMin");
  const bedroomMax = searchParams.get("bedroomMax");
  const numberOfBathrooms = searchParams.get("bathroom");
  const floors = searchParams.getAll("floor");
  const encodedSortBy = searchParams.get("sortBy");
  const sortedOption = findSortByOption(encodedSortBy);

  let geometries;
  if (zoneIds.length === 0) {
    geometries = polygons;
  } else {
    const filteredFeatures = locations.features.filter((feature) =>
      zoneIds.includes(feature.properties.FID_1)
    );
    geometries =
      filteredFeatures.length > 0
        ? filteredFeatures.map((feature) => feature.geometry)
        : polygons;
  }

  return {
    polygons: geometries,
    propertyType: formatPropertyType(
      reverseFormatPropertyTitle(propertyType),
      decodePropertyTypeDetails(propertyTypeDetails, propertyTypeDetailsList)
    ),
    zipCodes:
      zipCodes.length > 0
        ? zipCodes
        : searchedLocations.flatMap((location) =>
            location.zip.split(",").map((zip) => zip.trim())
          ),
    priceMin: priceMin,
    priceMax: priceMax,
    totalAreaMin: totalAreaMin,
    totalAreaMax: totalAreaMax,
    roomMin: roomMin,
    roomMax: roomMax,
    bedroomMin: bedroomMin,
    bedroomMax: bedroomMax,
    numberOfBathrooms: numberOfBathrooms ? parseInt(numberOfBathrooms) : null,
    floors: floors.map((floor) => floorMapping[floor] || floor),
    sortBy: sortedOption ? sortedOption.value : "most_recent",
  };
};
